module.exports = __webpack_public_path__ + "img/3d-rotation.0db13172.svg";